/** Words for an AI proposal (step-model E3, spec §5.4) — shared by the task
 * form, task detail and the record timeline so they never disagree. */

export const SUGGESTED_BY_AI = 'Suggested by AI'

/** 0.82 → "82%". Anything that is not a finite number yields null.
 *
 * SA-407: a rendered confidence never rounds UP — 0.796 against a 0.8
 * threshold must not read "80% — below the threshold". Whole percent when
 * that is exact or rounds down (0.794 → "79%"), otherwise one truncated
 * decimal (0.796 → "79.6%", 0.7996 → "79.9%"). One rule for the chip, the
 * summary and the timeline. A bare floor is not it: 0.82 * 100 is
 * 81.99999999999999, which is what the epsilon absorbs. */
export function formatConfidence(confidence: unknown): string | null {
  if (typeof confidence !== 'number' || !Number.isFinite(confidence)) return null
  const tenths = Math.floor(confidence * 1000 + 1e-6)
  const whole = Math.round(tenths / 10)
  return whole * 10 <= tenths ? `${whole}%` : `${(tenths / 10).toFixed(1)}%`
}
